// @see https://www.npmjs.com/package/react-native-vector-icons

import { FunctionComponent } from "react";
import { TIcon } from "../../../../api/v1_0";
import { ReactComponent as IconAdvertisement } from "../../../../icons/advertisement.svg";
import { ReactComponent as IconBag } from "../../../../icons/bag.svg";
import { ReactComponent as IconAkbars } from "../../../../icons/banks/ru/akbars.svg";
import { ReactComponent as IconAlfabank } from "../../../../icons/banks/ru/alfabank.svg";
import { ReactComponent as IconAtb } from "../../../../icons/banks/ru/atb.svg";
import { ReactComponent as IconCitiBank } from "../../../../icons/banks/ru/citi_bank.svg";
import { ReactComponent as IconDomrf } from "../../../../icons/banks/ru/domrf.svg";
import { ReactComponent as IconGazprom } from "../../../../icons/banks/ru/gazprom.svg";
import { ReactComponent as IconHomeCredit } from "../../../../icons/banks/ru/home_credit.svg";
import { ReactComponent as IconMkb } from "../../../../icons/banks/ru/mkb.svg";
import { ReactComponent as IconMts } from "../../../../icons/banks/ru/mts.svg";
import { ReactComponent as IconOtkritie } from "../../../../icons/banks/ru/otkritie.svg";
import { ReactComponent as IconOtp } from "../../../../icons/banks/ru/otp.svg";
import { ReactComponent as IconPaypal } from "../../../../icons/banks/ru/paypal.svg";
import { ReactComponent as IconPochtaBank } from "../../../../icons/banks/ru/pochta_bank.svg";
import { ReactComponent as IconPsbank } from "../../../../icons/banks/ru/psbank.svg";
import { ReactComponent as IconQiwi } from "../../../../icons/banks/ru/qiwi.svg";
import { ReactComponent as IconRaiffeisenbank } from "../../../../icons/banks/ru/raiffeisenbank.svg";
import { ReactComponent as IconRnkb } from "../../../../icons/banks/ru/rnkb.svg";
import { ReactComponent as IconRosbank } from "../../../../icons/banks/ru/rosbank.svg";
import { ReactComponent as IconRosgosstrakhBank } from "../../../../icons/banks/ru/rosgosstrakh_bank.svg";
import { ReactComponent as IconRusskiyStandart } from "../../../../icons/banks/ru/russkiy_standart.svg";
import { ReactComponent as IconSberbank } from "../../../../icons/banks/ru/sberbank.svg";
import { ReactComponent as IconSkb } from "../../../../icons/banks/ru/skb.svg";
import { ReactComponent as IconSovcombank } from "../../../../icons/banks/ru/sovcombank.svg";
import { ReactComponent as IconTinkoff } from "../../../../icons/banks/ru/tinkoff.svg";
import { ReactComponent as IconTochka } from "../../../../icons/banks/ru/tochka.svg";
import { ReactComponent as IconUbrd } from "../../../../icons/banks/ru/ubrd.svg";
import { ReactComponent as IconUnikredit } from "../../../../icons/banks/ru/unikredit.svg";
import { ReactComponent as IconUralsib } from "../../../../icons/banks/ru/uralsib.svg";
import { ReactComponent as IconVostochniy } from "../../../../icons/banks/ru/vostochniy.svg";
import { ReactComponent as IconVtb } from "../../../../icons/banks/ru/vtb.svg";
import { ReactComponent as IconYoomoney } from "../../../../icons/banks/ru/yoomoney.svg";
import { ReactComponent as IconBarChart } from "../../../../icons/bar-chart.svg";
import { ReactComponent as IconBasket } from "../../../../icons/basket.svg";
import { ReactComponent as IconBitcoin } from "../../../../icons/bitcoin.svg";
import { ReactComponent as IconBone } from "../../../../icons/bone.svg";
import { ReactComponent as IconBook } from "../../../../icons/book.svg";
import { ReactComponent as IconBriefcase } from "../../../../icons/briefcase.svg";
import { ReactComponent as IconBrightness } from "../../../../icons/brightness.svg";
import { ReactComponent as IconBrush } from "../../../../icons/brush.svg";
import { ReactComponent as IconCalendar } from "../../../../icons/calendar.svg";
import { ReactComponent as IconCd } from "../../../../icons/cd.svg";
import { ReactComponent as IconCoffee } from "../../../../icons/coffee.svg";
import { ReactComponent as IconComment } from "../../../../icons/comment.svg";
import { ReactComponent as IconCreditCard } from "../../../../icons/credit-card.svg";
import { ReactComponent as IconCross } from "../../../../icons/cross.svg";
import { ReactComponent as IconCup } from "../../../../icons/cup.svg";
import { ReactComponent as IconCursor } from "../../../../icons/cursor.svg";
import { ReactComponent as IconDelivery } from "../../../../icons/delivery.svg";
import { ReactComponent as IconGears } from "../../../../icons/gears.svg";
import { ReactComponent as IconGift } from "../../../../icons/gift.svg";
import { ReactComponent as IconGlobe } from "../../../../icons/globe.svg";
import { ReactComponent as IconHeart } from "../../../../icons/heart.svg";
import { ReactComponent as IconHome } from "../../../../icons/home.svg";
import { ReactComponent as IconHorse } from "../../../../icons/horse.svg";
import { ReactComponent as IconIceCream } from "../../../../icons/ice-cream.svg";
import { ReactComponent as IconLaptop } from "../../../../icons/laptop.svg";
import { ReactComponent as IconLightBulb } from "../../../../icons/light-bulb.svg";
import { ReactComponent as IconMarker } from "../../../../icons/marker.svg";
import { ReactComponent as IconMobile } from "../../../../icons/mobile.svg";
import { ReactComponent as IconMusicNote } from "../../../../icons/music-note.svg";
import { ReactComponent as IconPhone } from "../../../../icons/phone.svg";
import { ReactComponent as IconPocket } from "../../../../icons/pocket.svg";
import { ReactComponent as IconRemovedAccount } from "../../../../icons/removed-account.svg";
import { ReactComponent as IconRocket } from "../../../../icons/rocket.svg";
import { ReactComponent as IconShield } from "../../../../icons/shield.svg";
import { ReactComponent as IconWallet } from "../../../../icons/wallet.svg";
import { ReactComponent as IconWatch } from "../../../../icons/watch.svg";
import { ReactComponent as IconWorld } from "../../../../icons/world.svg";
import { ISvgImageProps } from "./types";

export const SvgImage: FunctionComponent<ISvgImageProps> = (
  props: ISvgImageProps
): any => {
  const { icon, style, size, ...restProps } = props;

  switch (icon) {
    // Default
    case TIcon.Advertisement:
      return (
        <IconAdvertisement
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Bag:
      return (
        <IconBag style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.BarChart:
      return (
        <IconBarChart style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Basket:
      return (
        <IconBasket style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Bitcoin:
      return (
        <IconBitcoin style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Bone:
      return (
        <IconBone style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Book:
      return (
        <IconBook style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Briefcase:
      return (
        <IconBriefcase
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Brightness:
      return (
        <IconBrightness
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Brush:
      return (
        <IconBrush style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Calendar:
      return (
        <IconCalendar style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Cd:
      return <IconCd style={style} width={size} height={size} {...restProps} />;
    case TIcon.Coffee:
      return (
        <IconCoffee style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Comment:
      return (
        <IconComment style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.CreditCard:
      return (
        <IconCreditCard
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Cross:
      return (
        <IconCross style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Cup:
      return (
        <IconCup style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Cursor:
      return (
        <IconCursor style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Delivery:
      return (
        <IconDelivery style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Gears:
      return (
        <IconGears style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Gift:
      return (
        <IconGift style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Globe:
      return (
        <IconGlobe style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Heart:
      return (
        <IconHeart style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Home:
      return (
        <IconHome style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Horse:
      return (
        <IconHorse style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.IceCream:
      return (
        <IconIceCream style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Laptop:
      return (
        <IconLaptop style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.LightBulb:
      return (
        <IconLightBulb
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Marker:
      return (
        <IconMarker style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Mobile:
      return (
        <IconMobile style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.MusicNote:
      return (
        <IconMusicNote
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Phone:
      return (
        <IconPhone style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Pocket:
      return (
        <IconPocket style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Rocket:
      return (
        <IconRocket style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Shield:
      return (
        <IconShield style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Wallet:
      return (
        <IconWallet style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Watch:
      return (
        <IconWatch style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.World:
      return (
        <IconWorld style={style} width={size} height={size} {...restProps} />
      );
    //	Banks
    case TIcon.Ubrd:
      return (
        <IconUbrd style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Akbars:
      return (
        <IconAkbars style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Alfabank:
      return (
        <IconAlfabank style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Atb:
      return (
        <IconAtb style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.CitiBank:
      return (
        <IconCitiBank style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Domrf:
      return (
        <IconDomrf style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Gazprom:
      return (
        <IconGazprom style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.HomeCredit:
      return (
        <IconHomeCredit
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Mkb:
      return (
        <IconMkb style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Mts:
      return (
        <IconMts style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Otkritie:
      return (
        <IconOtkritie style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Otp:
      return (
        <IconOtp style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Paypal:
      return (
        <IconPaypal style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.PochtaBank:
      return (
        <IconPochtaBank
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Psbank:
      return (
        <IconPsbank style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Qiwi:
      return (
        <IconQiwi style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Raiffeisenbank:
      return (
        <IconRaiffeisenbank
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Rnkb:
      return (
        <IconRnkb style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Rosbank:
      return (
        <IconRosbank style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.RosgosstrakhBank:
      return (
        <IconRosgosstrakhBank
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.RusskiyStandart:
      return (
        <IconRusskiyStandart
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Sberbank:
      return (
        <IconSberbank style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Skb:
      return (
        <IconSkb style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Sovcombank:
      return (
        <IconSovcombank
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Tinkoff:
      return (
        <IconTinkoff style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Tochka:
      return (
        <IconTochka style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Unikredit:
      return (
        <IconUnikredit
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Uralsib:
      return (
        <IconUralsib style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Vostochniy:
      return (
        <IconVostochniy
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    case TIcon.Vtb:
      return (
        <IconVtb style={style} width={size} height={size} {...restProps} />
      );
    case TIcon.Yoomoney:
      return (
        <IconYoomoney style={style} width={size} height={size} {...restProps} />
      );
    //	Removed
    case "removed-account" as any:
      return (
        <IconRemovedAccount
          style={style}
          width={size}
          height={size}
          {...restProps}
        />
      );
    //	Else
    default:
      return null;
  }
};
